import { __makeTemplateObject } from "tslib";
import { Flex } from '@marvelapp/ui';
import styled, { css } from 'styled-components';
var SpecsBorderItem = styled(Flex).attrs({
    borderBottom: '1px solid',
    borderColor: 'smoke',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  max-width: 100%;\n  ", ";\n"], ["\n  max-width: 100%;\n  ",
    ";\n"])), function (props) {
    return !props.ignoreLastChild && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      &:last-child {\n        border: none !important;\n        margin: 0 !important;\n        padding: 0 !important;\n      }\n    "], ["\n      &:last-child {\n        border: none !important;\n        margin: 0 !important;\n        padding: 0 !important;\n      }\n    "])));
});
export default SpecsBorderItem;
var templateObject_1, templateObject_2;
